import React, { useState, useEffect, useCallback } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import SwiperCore, { Pagination, Navigation, A11y } from 'swiper';

import Header from '../../components/HeaderView';

import style from './styles';

import 'swiper/swiper-bundle.css';
import 'swiper/swiper.min.css';
import 'swiper/components/navigation/navigation.min.css';
import 'swiper/components/pagination/pagination.min.css';
import 'swiper/components/scrollbar';

import useUserContext from '../../hooks/useUserContext';
import useConfigContext from '../../hooks/useConfigContext';
import useModalLoginContext from '../../hooks/useModalLoginContext';

import './style.css';
import styles from './styles.module.scss';
import globalStyles from '../../styles/global.module.scss';
import Maintenance from '../../components/templates/maintenance';
import MobileBanner from '../../components/templates/mobileBanner';

SwiperCore.use([Navigation, Pagination, A11y]);

const stylesTheme = theme => style(theme);

function Home() {
  const { userState } = useUserContext();
  const { configState } = useConfigContext();
  const { deliveries, shoes, swimwear } = configState;
  const seasonName = configState.season.name || '';
  const homeConfig = configState.home;
  const { show: showModalLogin } = useModalLoginContext();

  const [wid, setWid] = useState(window.innerWidth);

  const isAuthenticated = Boolean(userState.token);

  const updateViewportWidth = useCallback(() => {
    setWid(prevWidth => {
      const shouldUpdate =
        (prevWidth > 1024 && window.innerWidth < 1024) ||
        (prevWidth < 1024 && window.innerWidth > 1024);
      if (shouldUpdate) return window.innerWidth;
      return prevWidth;
    });
  }, [setWid]);

  useEffect(() => {
    window.scrollTo(0, 0);
    window.addEventListener('resize', updateViewportWidth);
    return () => {
      window.removeEventListener('resize', updateViewportWidth);
    };
  }, [updateViewportWidth]);

  const DeliveryCard = ({
    id,
    backgroundUrl,
    subTitle1,
    subTitle2,
    title,
    url,
    upperTitle,
    singleDelivery,
    collection,
  }) => {
    return (
      <div
        style={{ width: singleDelivery && '99%' }}
        className={styles.cardWrapper}
      >
        <Link
          className={`${globalStyles.link}  ${
            singleDelivery ? styles.singleDeliveryCard : styles.deliveryCard
          }`}
          key={id}
          style={{
            backgroundImage: `url(${backgroundUrl})`,
          }}
          to={`${url}`}
        >
          <div
            className={styles.deliveryCardTextWrapper}
            style={{ left: singleDelivery && '0.5%' }}
          >
            <div className={style.upperTitle}>{upperTitle}</div>
            <span style={{ position: 'relative', left: 5 }}>{collection} </span>
            <div style={{ position: 'relative', bottom: 5 }}>
              <h3>{title}</h3>
              <h4>{`${subTitle1 || ''} ${subTitle2 ? '|' : ''} ${subTitle2 ||
                ''}`}</h4>
            </div>
          </div>
        </Link>
      </div>
    );
  };

  const Sustainability = () => {
    const backgroundMobile = isAuthenticated
      ? homeConfig.sustainability.bgMobSignedIn
      : homeConfig.sustainability.bgMobNotSignedIn;
    const backgroundDesk = isAuthenticated
      ? homeConfig.sustainability.bgDeskSignedIn
      : homeConfig.sustainability.bgDeskNotSignedIn;

    return (
      <section
        style={{ height: window.innerHeight }}
        className={styles.section}
      >
        <picture className={styles.background}>
          <source media="(max-width:1024px)" srcSet={backgroundMobile} />
          <img src={backgroundDesk} height={window.innerHeight} alt="" />
        </picture>

        <div className={styles.boxedContent}>
          <div className={styles.textBox}>
            <h2>Sustainability</h2>
            <p>
              Nature has always been your home. We are passionate about taking
              impactful steps to ensure it will keep inpiring new generations
              with its beauty and diversity.
            </p>
          </div>
          <Link className={styles.callToAction} to="/sustainability">
            Discover
          </Link>
        </div>
      </section>
    );
  };

  const WhoWeAre = () => {
    const backgroundMobile = isAuthenticated
      ? homeConfig.whoWeAre.bgMobSignedIn
      : homeConfig.whoWeAre.bgMobNotSignedIn;
    const backgroundDesk = isAuthenticated
      ? homeConfig.whoWeAre.bgDeskSignedIn
      : homeConfig.whoWeAre.bgDeskNotSignedIn;

    return (
      <section
        style={{
          height: window.innerHeight,
          position: isAuthenticated ? undefined : 'relative',
          top: isAuthenticated ? undefined : 77,
        }}
        className={styles.section}
      >
        <picture className={styles.background}>
          <source media="(max-width:1024px)" srcSet={backgroundMobile} />
          <img src={backgroundDesk} height={window.innerHeight} alt="" />
        </picture>

        <div className={styles.boxedContent}>
          <div className={styles.textBox}>
            <h2>Who we are</h2>
            <p>
              We are a group of creatives from Rio de Janeiro, Brazil, that
              believe in the existence of happiness. More than a brand, we
              create enlightened cultural movements since 1997.
            </p>
          </div>
          <Link className={styles.callToAction} to="/whoweare">
            Discover
          </Link>
        </div>
      </section>
    );
  };

  const WelcomeSS2022 = () => {
    const backgroundMobile = isAuthenticated
      ? homeConfig.welcome.bgMobSignedIn
      : homeConfig.welcome.bgMobNotSignedIn;
    const backgroundDesk = isAuthenticated
      ? homeConfig.welcome.bgDeskSignedIn
      : homeConfig.welcome.bgDeskNotSignedIn;

    const handleClick = e => {
      if (!isAuthenticated) {
        e.preventDefault();
        showModalLogin();
      }
    };

    return (
      <section
        style={{
          height: window.innerHeight,
          position: isAuthenticated ? 'relative' : undefined,
          top: isAuthenticated ? 77 : undefined,
        }}
        className={styles.section}
      >
        <picture className={styles.background}>
          <source media="(max-width:1024px)" srcSet={backgroundMobile} />
          <img src={backgroundDesk} height={window.innerHeight} alt="" />
        </picture>

        <div className={styles.centralizedContent}>
          <h2>Welcome to {seasonName}</h2>
          <Link
            className={styles.callToAction}
            to="/delivery/1/view"
            onClick={handleClick}
          >
            See the collection
          </Link>
        </div>
      </section>
    );
  };

  const Deliveries = () => {
    const mainDeliveries = deliveries.filter(
      d => d.active && (d.id === 1 || d.id === 2 || d.id === 3)
    );
    const activeSwim = swimwear.filter(s => s.active).slice(0, 1);
    const activeShoes = shoes.filter(s => s.active).slice(0, 1);

    const renderThreeColCards = items => (
      <div
        className={`${styles.deliveriesWrapper} ${styles.threeColumnWrapper}`}
      >
        {items.map(item => (
          <DeliveryCard
            backgroundUrl={item.backgroundUrl}
            url={item.url}
            subTitle1={item.subTitle1}
            subTitle2={item.subTitle2}
            title={item.title}
            id={item.id}
            key={item.id}
            collection={item.collection}
            upperTitle={item.upperTitle}
          />
        ))}
      </div>
    );

    const renderFullWidthCard = item => (
      <div
        key={`single-${item.id}`}
        className={`${styles.deliveriesWrapper} ${styles.singleDeliveryWrapper}`}
      >
        <DeliveryCard
          backgroundUrl={item.backgroundUrl}
          url={item.url}
          title={wid > 1024 ? item.title : ''}
          id={item.id}
          singleDelivery
          upperTitle={item.upperTitle}
        />
      </div>
    );

    return (
      <section className={styles.section}>
        {mainDeliveries.length > 0 && renderThreeColCards(mainDeliveries)}

        {activeSwim.map(s => renderFullWidthCard(s))}

        {activeShoes.map(s => renderFullWidthCard(s))}
      </section>
    );
  };

  const Interested = () => {
    return (
      <>
        <section
          style={{ height: window.innerHeight }}
          className={`${styles.section} ${styles.noBackground}`}
        >
          <div className={styles.centralizedContent}>
            <h2>Interested in selling FARM Rio?</h2>
            <p>
              Complete our application and you&apos;ll receive an answer
              shortly.
            </p>
            <Link className={styles.callToAction} to="/register">
              Apply now
            </Link>
          </div>
        </section>
      </>
    );
  };

  const siteIsMaintenanceMode =
    process.env.REACT_APP_MAINTENANCE_MODE === 'enabled' &&
    !userState.user.admin;

  const isMobileViewport = wid < 1024;

  if (isMobileViewport) {
    return <MobileBanner />;
  }

  return (
    <>
      <Header />
      {siteIsMaintenanceMode ? (
        <Maintenance />
      ) : !isAuthenticated ? (
        <>
          <WhoWeAre />
          <WelcomeSS2022 />
          <Deliveries />
          <Interested />
          <Sustainability />
        </>
      ) : (
        isAuthenticated && (
          <>
            <WelcomeSS2022 />
            <Deliveries />
            <WhoWeAre />
            <Sustainability />
          </>
        )
      )}
    </>
  );
}

export default withStyles(stylesTheme)(Home);
